// extracted by mini-css-extract-plugin
export var principles = "principles-module--principles--a849b";
export var principles__container = "principles-module--principles__container--48c05";
export var principles__text = "principles-module--principles__text--f813b";
export var principles__title = "principles-module--principles__title--f8739";